import { lazy } from 'react';
import { IconCalendarTime, IconFileAnalytics, IconHistory, IconLayoutDashboard, IconReportAnalytics, IconTableOptions } from '@tabler/icons-react';
import { defineModule } from '../types';
import { indexRoute, lazyRoute, routeGroup } from '../routing';
import { ANY_DASHBOARD, ANY_SCHEDULE, P } from './perms';

const widgets = () => import('./widgets');
const MyDashboardWidget = lazy(() => widgets().then((m) => ({ default: m.MyDashboardWidget })));

const dashboards = () => import('./pages/DashboardPages');
const reports = () => import('./pages/ReportsPages');
const schedules = () => import('./pages/SchedulesPages');

/**
 * RPT — Reports & dashboards / التقارير ولوحات المؤشرات (FR-RPT-01..07)
 * Role dashboards, report catalogue & runner, my reports, e-mail schedules & packs,
 * limited self-service builder.
 */
export default defineModule({
  code: 'rpt',
  nameAr: 'التقارير',
  nameEn: 'Reports',
  icon: IconReportAnalytics,
  order: 160,
  menu: [
    { key: 'rpt.dashboards', labelKey: 'rpt:nav.dashboards', path: '/rpt/dashboards', icon: IconLayoutDashboard, permission: ANY_DASHBOARD },
    { key: 'rpt.reports', labelKey: 'rpt:nav.reports', path: '/rpt/reports', icon: IconFileAnalytics, permission: P.run },
    { key: 'rpt.runs', labelKey: 'rpt:nav.myReports', path: '/rpt/runs', icon: IconHistory, permission: P.run },
    { key: 'rpt.schedules', labelKey: 'rpt:nav.schedules', path: '/rpt/schedules', icon: IconCalendarTime, permission: ANY_SCHEDULE },
    { key: 'rpt.builder', labelKey: 'rpt:nav.builder', path: '/rpt/builder', icon: IconTableOptions, permission: P.builder.use },
  ],
  routes: {
    admin: [
      routeGroup('rpt/dashboards', 'rpt:nav.dashboards', [
        indexRoute(() => dashboards().then((m) => ({ default: m.DashboardsPage })), ANY_DASHBOARD),
        lazyRoute(':code', () => dashboards().then((m) => ({ default: m.DashboardPage })), { permission: ANY_DASHBOARD, crumb: 'rpt:dashboard.crumb' }),
      ]),
      routeGroup('rpt/reports', 'rpt:nav.reports', [
        indexRoute(() => reports().then((m) => ({ default: m.ReportsCatalogPage })), P.run),
        lazyRoute(':code', () => reports().then((m) => ({ default: m.ReportRunPage })), { permission: P.run, crumb: 'rpt:reports.run' }),
      ]),
      lazyRoute('rpt/runs', () => reports().then((m) => ({ default: m.RunsPage })), { permission: P.run, crumb: 'rpt:nav.myReports' }),
      routeGroup('rpt/schedules', 'rpt:nav.schedules', [
        indexRoute(() => schedules().then((m) => ({ default: m.SchedulesPage })), ANY_SCHEDULE),
        lazyRoute(':id', () => schedules().then((m) => ({ default: m.ScheduleDetailPage })), { permission: ANY_SCHEDULE, crumb: 'rpt:schedules.detail' }),
      ]),
      lazyRoute('rpt/builder', () => import('./pages/BuilderPage').then((m) => ({ default: m.BuilderPage })), { permission: P.builder.use, crumb: 'rpt:nav.builder' }),
    ],
  },
  dashboards: [{ key: 'rpt.myDashboard', titleKey: 'rpt:widgets.myDashboard', component: MyDashboardWidget, permission: ANY_DASHBOARD, order: 5, span: { base: 12, lg: 8 } }],
});
